// Analytics event shapes over the lifecycle adapter. Owns the payload construction
// that call sites used to repeat, so the event name + key mapping live in one place.
//
// Live-agent + survey lifecycle analytics all ride the `submit-click` event with the
// same 5-key shape, discriminated by `lvQuestion`. Six call sites (agent connect /
// disconnect ×2 / custom-message / survey started / survey received) built this object
// inline; this centralizes it. The domain values (session id, Sprinklr conversation /
// case) stay caller-supplied — only the shape is shared.
import { createActionId } from '../platform/session/session';
import { emit } from '../platform/events/lifecycle';

/**
 * Emit a live-agent / survey lifecycle analytics event (the `submit-click` shape).
 * @param {Object} params
 * @param {string} params.lvQuestion       the analytics discriminator string
 * @param {string} params.sessionId        maps to payload `sessionID`
 * @param {string} [params.actionId]       maps to payload `actionID`; defaults to createActionId(sessionId)
 * @param {string} params.conversationId   maps to payload `sprinklrSession`
 * @param {string} params.caseNumber       maps to payload `sprinklrCase`
 */
export const emitLiveAgentAnalytics = ({
  lvQuestion, sessionId, actionId, conversationId, caseNumber,
}) => {
  emit('magic-apron-assistant.submit-click', {
    lvQuestion,
    sessionID: sessionId,
    actionID: actionId ?? createActionId(sessionId),
    sprinklrSession: conversationId,
    sprinklrCase: caseNumber,
  });
};
